import Logger from '../lib/logger';

class CustomTextRadioGroup extends HTMLElement {
  #NAME = 'CustomTextRadioGroup'
  #abortController
  customTextInput
  inputs

  constructor() {
    super();
    Logger.info(`${this.#NAME} > constructor`);
    this.customTextInput = this.nextElementSibling;
    this.inputs = Array.from(this.querySelectorAll('input'));
  } 

  connectedCallback() {
    Logger.info(`${this.#NAME} > connectedCallback`);
    //
    this.#abortController = new AbortController();
    const { signal } = this.#abortController;
    //
    this.inputs.forEach(input => {
      input.addEventListener('input', (e) => this.#onInput(e), { signal });
    });
  }

  disconnectedCallback() {
    this.#abortController.abort();
    this.#abortController = null;
  }

  static get observedAttributes() {
    return ['data-disabled'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-disabled' && newValue !== oldValue) {
      if (newValue === 'true') {
        setTimeout(() => {
          /* this.#onInput({ target: { value: 'No' }}); */
          this.customTextInput.inputs.forEach(input => input.disabled = true);
          this.inputs.forEach(input => {input.disabled = true; input.required = false});
        }, 0);
        
      } else {
        setTimeout(() => {
          this.customTextInput.inputs.forEach(input => input.disabled = false);
          this.inputs.forEach(input => {input.disabled = false; input.required = true});
          if (this.inputs.find(input => input.checked === true)) this.#onInput({ target: { value: 'Yes' }});
        }, 0);
      }
    }
  }

  #onInput(e) {
    if (e.target.value === 'Yes') {
      this.customTextInput.dataset.show = true;
      this.customTextInput.dataset.required = true;
      this.customTextInput.inputs.forEach(input => input.disabled = false);
    } else {
      this.customTextInput.dataset.show = false;
      this.customTextInput.dataset.required = false;
      this.customTextInput.inputs.forEach(input => input.disabled = true);
    }
  }
}

customElements.define('custom-text-radio-group', CustomTextRadioGroup);